export default "__VITE_ASSET__DFnNspC$__"